import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=07900f93&scoped=true&"
import script from "./agentDetail.vue?vue&type=script&lang=js&"
export * from "./agentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07900f93",
  null
  
)

export default component.exports